export default "__VITE_PUBLIC_ASSET__3a76ade3__"